export default {
  add ({ commit, state }, val) {
    const count = state.themes.length
    commit('create', val)
    commit('change', count)
  }
}